export default "__VITE_ASSET__Jlvwxnxb__"